class Plugin {
    datatable = null;

    constructor($table, config, tableInstance) {
        this.$table = $table;
        this.config = config;
        this.tableInstance = tableInstance;
    }
    
    boot() { }

    init() { }

    setDatatable(datatable) {
        this.datatable = datatable;
    }
}

export default Plugin;
